import React, { FC, Suspense } from "react";
import { Route } from "react-router";
import LoginLayout from "./LoginLayout";
import { AppLayoutProps } from "../types";
import Loader from "../../../atoms/Loader";

const LoginRouteLayout: FC<AppLayoutProps> = ({
  component: Component,
  render: renderFunc,
  ...rest
}) => (
  <Route
    render={(matchProps) => (
      <LoginLayout>
        <Suspense fallback={<Loader />}>
          {Component !== undefined && <Component {...matchProps} />}
          {renderFunc !== undefined && renderFunc(matchProps)}
        </Suspense>
      </LoginLayout>
    )}
    {...rest}
  />
);

export default LoginRouteLayout;
